<template>
  <koyoukeiyaku-pdfdisp />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import KoyouKeiyakuPdfDisp from '@/components/koyoukeiyaku/PdfDisp.vue'

export default defineComponent({
  setup() {
    return {}
  },
  components: {
    'koyoukeiyaku-pdfdisp': KoyouKeiyakuPdfDisp
  }
})
</script>
